module.exports = __webpack_public_path__ + "static/media/0.155a8d2a.jpg";